import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.your_company.payment_details.title',
        defaultMessage: 'Payment Details'
    },
    subtitle: {
        id: '_.your_company.profile.payment_details.subtitle',
        defaultMessage:
            'To complete your profile, you just need to add your business bank details so we know which account to fund and your debit card details, so we know which card to take your scheduled repayments from.'
    },
    addBankAccount: {
        id: '_.your_company.payment_card_label.add_bank_account',
        defaultMessage: 'Business bank details'
    },
    addDebitCard: {
        id: '_.your_company.payment_card_label.add_debit_card',
        defaultMessage: 'Add debit card'
    },
    addBankNumberAndDebitCard: {
        id: '_.your_company.payment_card_label.add_bank_account_or_debit_card',
        defaultMessage: 'Add bank account or debit card'
    },
    addDirectDebitMandate: {
        id: '_.your_company.payment_card_label.add_direct_debit_mandate',
        defaultMessage: 'Add new direct debit mandate'
    },
    directDebitModalTitle: {
        id: '_.your_company.payment_card_label.direct_debit_modal_title',
        defaultMessage: "We're working on it!"
    },
    directDebitModalDescription: {
        id: '_.your_company.payment_card_label.direct_debit_modal_description',
        defaultMessage:
            'It will soon be possible to add a new direct debit mandate here. If you do not have an active direct debit mandate, please transfer your installments manually. If you have any questions, please call us on {phone} or send us an email to {email}.'
    }
});
